import React, { Component, PropTypes } from 'react';

import Repos from './about/Repos';

import Loader from './layout/Loader';
import Banner from './layout/Banner';
import global from '../global';
import { observer } from 'mobx-react';
import mobx from 'mobx';
import { Link } from 'react-router';

const About = observer(class About extends Component {
	constructor(props) {
		super(props);
	}

	render () {
		let isFetching = global.store.isFetching;
		let results = global.store.repos;
		let error  = null;
		return (
			<div>
				<Banner />
				<div className="about">
					<h3>About Me</h3>
{/*
					<p className="">I am a Software Programmer based in Davao City, Philippines. I have been creating web apps for the past couple of years now.</p>

					<p className="hidden">I have adopted, mastered and moved on from many languages, frameworks and architectures. I currently focus on Javascript heavy web application development.</p>

					<p className="hidden">I first joined a local startup mid 2013 called Salt, where much of my experience as a developer grew. My role moved from a front-end coder expanded to backend coder and later mobile android as well. I built multiple of MVP products for that group.</p>

					<p className="hidden">My year 2014 mostly was spent building several Wordpress sites (<a href="http://www.dentalonkennedy.com.au" target="_blank">Dental on kennedy</a>, <a href="http://thebeachfurniture.com.au" target="_blank">The Beach Furniture</a>) and one Magento Ecommerce (<a href="http://globalsupplements.com.au" target="_blank">Global Supplements</a>) for clients of Diverse website solutions each on a tight schedule.</p>

					<p className="hidden">Towards the end of 2014 I developed a web app for <a href="http://rsaglobal.net.au" target="_blank">RSA</a>. Later this year (2016) they expanded and added an IOS version of it. I built it using React Native.</p>

					<p className="hidden">Over the years, I built tons of apps from simple to complex, from websites to native apps, to hybrid apps, and ranging from augmented reality, to proximity aware apps. After all that I realized that I indeed have a passion for programming and app development.</p> */}

				</div>
				<div className="repos">
					<h3><a href="https://github.com/malkio?tab=repositories	" target="_blank">My GitHub</a> Repos</h3>
					{isFetching && results.length === 0 &&
						<Loader />
					}
					{!isFetching && error && results.length === 0 &&
						<h3 className="post-error">There has been an Error</h3>
					}
					{!isFetching && !error && results.length === 0 &&
						<h3>Empty</h3>
					}
					{results.length > 0 &&
						<div style={{ opacity: isFetching ? 0.5 : 1 }}>
							<Repos results={results} />
						</div>
					}
				</div>

			</div>
		);
	}
})

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js